import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()
export class GlobalSpinnerInterceptor implements HttpInterceptor {
  constructor(private spinner: NgxSpinnerService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const skipSpinner = request.headers.has('X-Skip-Spinner');

    if (skipSpinner) {
      return next.handle(request.clone({ headers: request.headers.delete('X-Skip-Spinner') }));
    }

    this.spinner.show();
    return next.handle(request).pipe(
      finalize(() => this.spinner.hide()),
    );
  }
}
